import { BASE_URL, BASE_URL_LEGACY } from "./";

export const activityService = {
  getDailyDetail,
  getWeeklyDetail,
  getTimeline,
  getOffDayAlerts,
};

function getTimeline(user, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/common/appliances/timeline/?user_id=${user}&timestamp=${timestamp}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

function getDailyDetail(dependant_user_id, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/assisted_living/daily_activities/?dependant_user_id=${dependant_user_id}&timestamp=${timestamp}`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function getOffDayAlerts(dependant_user_id, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": localStorage.getItem("CSRF"),
    },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL}/daily_activities/?dependant_user_id=${dependant_user_id}&timestamp=${timestamp}`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function getWeeklyDetail(dependant_user_id, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    // `${BASE_URL}/assisted_living/weekly_activities/?dependant_user_id=${dependant_user_id}&timestamp=${timestamp}`,
    `${BASE_URL}/weekly_activities/?dependant_user_id=${dependant_user_id}&timestamp=${timestamp}`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
